import { getFileMappingTask } from '@/services/implementationmanagement.api';
import { formatDateToWrittenDate } from '@/helpers/dates';

export async function buildFileMapping (taskId) {

    // Call identity verification API to get the status of the identity verification process
    var response = await getFileMappingTask(taskId);

    if(response.status !== 200 || response.data === null || response.data === undefined) {
        console.error('Error fetching data collection task');
        return null;
    }

    const task = response.data;

    const card = {
    id: task.taskId,
    title: task.taskName,
    subtitle: 'We\'re mapping your files now.',
    progress: 0,
    subProgressMessage: '',
    status: task.taskStatus,
    route: '/tasks/file-mapping/' + task.taskId, 
    createdDate: new Date(task.createdDate)
  }
    
  return card 
}

